export default {
  CONTROL_WARNING_TITLE: 'Points juridiques à vérifier',
  CONTROL_WARNING_TEXT: 'Le document a été généré, mais certains éléments fournis peuvent présenter un risque ou une contradiction juridique. Veuillez les vérifier avant utilisation.',
  CONTROL_WARNING_ACK: 'J’ai lu et compris',
  GERER: {
    TITRE: 'Mes documents',
    BTN: 'Interroger vos documents',
    CREATEDOC: 'Créer un document',
    FILTER1: {
      TOUS: 'Tous les salariés',
      PRIVATE: 'Privé',
      TEAM: 'Equipe',
      Site: 'Site',
    },
    FILTER2: {
      ATTENTE: 'En attente',
      INDEXATION: 'Indexation...',
      INDEXE: 'Indexé',
      ERR: 'Erreur',
    },
    TABLE: {
      COL1: 'Nom du document',
      COL2: 'Visibilité',
    },
  },
  CONTRACT: {
    ASSOCIATE: 'Associer le document au contrat',
    ASSOCIATED: 'Document associé au contrat avec succès',
    DISSOCIATED: 'Document désassocié du contrat avec succès',
    ASSOCIATION_ERROR: "Erreur lors de l'association du document",
    DISSOCIATION_ERROR: 'Erreur lors de la désassociation du document',
    LOAD_ERROR: 'Impossible de charger les documents associés au contrat. Actualisez avant de modifier les associations.',
  },
  INTERROGER: {
    REP: 'Réponse courte',
    Source: 'Source',
    Extrait: 'Extrait',
    LOADING: 'Chargement du document...',
    TXT: 'Vous pouvez interroger vos documents',
    BTN_NEW: 'Nouvelle question',
    BTN_CLOSE: 'Fermer',
  },
  UPLOAD: {
    title: 'Ajouter des documents',
    txt: 'Veuillez importer vos documents',
    error:
      "*Les comptes gratuits sont limités aux fichiers pdf de 30 pages max et 5Mo max. Si vous souhaitez lever ces limites, vous pouvez passer à l'offre premium.",
    visibilite: 'Changer la visibilité du document',
    prive: 'Privé',
    equipe: 'Equipe',
    site: 'Site',
    ts: 'Tous',
    doc_selectionne: 'Document sélectionnés',
    Fermer: 'Fermer',
    En_cours: 'En cours...',
    Soumettre: 'Soumettre',
    SUCCESS: '{{name}} : import réussi. Veuillez patienter pendant le traitement.',
    CONTRACT_SUCCESS: '{{name}} : document importé et associé au contrat. Le traitement est en cours.',
    UPLOAD_ERROR: "{{name}} : erreur lors de l'import du document. Vous pouvez réessayer avec Soumettre.",
    INVALID_RESPONSE: "{{name}} : l'import n'a pas renvoyé un identifiant de document valide. Vérifiez la GED avant de réessayer.",
    SUBSCRIPTION_ERROR: "{{name}} : votre abonnement n'est pas valide.",
    TEMPORARY_ERROR: '{{name}} : erreur temporaire. Veuillez réessayer ultérieurement.',
    CREDIT_ERROR: '{{name}} : crédits insuffisants pour importer le document.',
    ASSOCIATION_RETRY_ERROR: "{{name}} : document importé, mais association au contrat échouée. Cliquez sur Soumettre pour retenter l'association sans réimporter le fichier.",
  },
  EDIT: {
    title: 'Détails du document',
    EN_ATTENTE: 'En attente',
    INDEXATION: 'Indexation...',
    INDEXE: 'Indexé',
    ERR: 'Erreur',
    titre_doc: 'Titre du document',
    auteur: 'Auteur',
    IMPORTEEPAR: 'Importé par',
    DATE: "Date d'import",
    nbrPages: 'Nombres des pages',
    Version: 'Version',
    Sujet: 'Sujet',
    Resume: 'Résumé',
    listUser: 'Liste des utilisateurs concernés',
    Email: 'Email',
    Telephone: 'Téléphone',
    Entreprise: 'Entreprise',
    Fonction: 'Fonction',
    listeVide: "Pas d'utilisateurs concernés",
    add: 'Ajouter',
    addUser: {
      title: 'Ajouter des utilisateurs',
      txt: "Sélectionner l'utilisateur à ajouter à la liste des utilisateurs",
    },
  },
  GENERATION_ASSISTANT: {
    TITLE: 'Assistant IA',
    SUBTITLE: 'Complétez les informations manquantes avant génération.',
    WELCOME: 'Je peux affiner les informations avant génération. Répondre aux questions permet d’obtenir un document plus complet, plus précis et avec moins de valeurs par défaut.',
    SELECT_COLLABORATOR: 'Sélectionnez d’abord un collaborateur pour que je puisse vérifier les informations disponibles.',
    OPEN: 'Assistant IA',
    HIDE: 'Masquer assistant',
    THINKING: 'Analyse en cours...',
    READY: 'Prêt',
    MISSING_STATUS: 'Infos manquantes',
    MISSING_MODAL_TITLE: 'Informations manquantes',
    MISSING_MODAL_TEXT: 'Certaines informations semblent encore manquantes. Vous pouvez revenir à l’assistant pour les compléter ou générer quand même.',
    BACK_TO_ASSISTANT: 'Retour à l’assistant',
    CONTINUE_ANYWAY: 'Générer quand même',
    RETAINED_INSTRUCTIONS: 'Instructions retenues',
    INPUT_PLACEHOLDER: 'Ajoutez une précision ou répondez à la question...',
    APPLY: 'Utiliser ces instructions',
    APPLIED: 'Instructions appliquées',
    AUTO_USED: 'Ces instructions seront utilisées automatiquement à la génération.',
    MANUAL_EDIT: 'Modifier manuellement',
    HIDE_MANUAL: 'Masquer la saisie manuelle',
    MANUAL_LABEL: 'Instruction manuelle complémentaire',
    MANUAL_PLACEHOLDER: 'Ex: ne pas inclure la signature, rédiger en anglais, ajouter une mention pour la banque...',
    NO_INSTRUCTIONS: 'Aucune instruction spécifique pour le moment. Utilisez l’assistant IA pour préciser le document.',
    ERROR: "Erreur lors de l'appel à l'assistant",
    GENERATION_ERROR: 'Erreur lors de la génération du document',
    SKIP_OPTIONAL: 'Passer',
    AI_WARNING: 'DOCUMENT GÉNÉRÉ PAR IA. Ce document a été généré automatiquement et ne constitue pas un conseil juridique. Vérifiez sa conformité (convention collective, Code du travail) avant signature ou diffusion.',
    LOADING_PREPARE: "Préparation du document...",
    LOADING_GENERATING: "Génération du document en cours...",
    LOADING_CONTROLLING: "Contrôle qualité du document...",
    LOADING_CORRECTING: "Corrections et ajustements...",
    LOADING_FINALIZING: "Finalisation du document...",
    GENERATION_PAUSED_TITLE: "Information nécessaire",
    GENERATION_PAUSED_TEXT: "Répondez à la question ci-dessous pour poursuivre la génération du document.",
    JULIE_ENABLED: 'Julie activée',
    JULIE_DISABLED: 'Julie désactivée',
  },
  FOLDER: {
    CREATE: {
      TITLE: 'Créer un nouveau dossier',
      NAME_LABEL: 'Nom du dossier',
      NAME_PLACEHOLDER: 'Entrez le nom du dossier',
      NAME_REQUIRED: 'Le nom du dossier est requis',
      COLLABORATOR: 'Collaborateur',
      OPTIONAL: 'optionnel',
      SUBMIT: 'Créer',
      SUCCESS: 'Dossier créé avec succès',
      ERROR: 'Erreur lors de la création du dossier',
      SELECT_TEAM: 'Veuillez sélectionner une équipe',
      SELECT_SITE: 'Veuillez sélectionner un site',
    },
    RENAME: {
      TITLE: 'Renommer le dossier',
      NEW_NAME_LABEL: 'Nouveau nom',
      NEW_NAME_PLACEHOLDER: 'Entrez le nouveau nom',
      NAME_REQUIRED: 'Le nom est requis',
      PARENT_LABEL: 'Dossier parent',
      OPTIONAL: 'optionnel',
      ROOT_OPTION: 'Racine',
      SAVE: 'Enregistrer',
      INVALID_PARENT: "Un dossier ne peut pas être son propre parent",
      SUCCESS: 'Dossier mis à jour',
      ERROR: 'Erreur lors de la mise à jour du dossier',
    },
    LIST: {
      CREATE_FOLDER_BTN: 'Créer un dossier',
      ROOT: 'Racine',
      SECTION_TITLE: 'Dossiers',
      EMPTY_TITLE: 'Aucun dossier',
      EMPTY_SUBTITLE: 'Créez votre premier dossier pour organiser vos documents',
      RENAME_TOOLTIP: 'Renommer le dossier',
      DELETE_TOOLTIP: 'Supprimer le dossier',
    },
    MOVE_TO_FOLDER: 'Déplacer vers dossier',
    DELETE: {
      TITLE_FOLDER: 'Supprimer dossier',
      TITLE_DOCUMENT: 'Supprimer document',
      DELETION_OF: 'Suppression de "{{name}}"',
      DELETING_FOLDER: 'Suppression dossier...',
      DELETING_DOCUMENT: 'Suppression document...',
      FOLDER_CONFIRMATION: "Êtes-vous sûr de vouloir supprimer ce dossier ? Tous les documents qu'il contient seront également supprimés.",
      CONFIRMATION_GENERIC: 'Êtes-vous sûr de vouloir supprimer définitivement cet élément?',
      CONFIRM_LABEL: 'Pour confirmer la suppression, veuillez taper "{{confirm}}" ci-dessous:',
      CONFIRM_PLACEHOLDER: 'Tapez {{confirm}} pour confirmer',
      CONFIRM_MISMATCH: 'Le texte ne correspond pas. Tapez exactement "{{confirm}}" pour confirmer.',
      ERROR_GENERIC: "Une erreur s'est produite lors de la suppression.",
      CANCEL: 'Annuler',
      DELETE: 'Supprimer',
      DELETING: 'Suppression...',
      CONFIRM_WORD: 'Supprimer',
      SUCCESS_FOLDER: 'Dossier supprimé avec succès',
      ERROR_FOLDER: 'Erreur lors de la suppression du dossier',
    },
    ACTIONS: {
      CANCEL: 'Annuler',
      SAVE: 'Enregistrer',
      SELECT_FOLDER_REQUIRED: 'Veuillez sélectionner un dossier',
    },
    ERRORS: {
      NOT_FOUND: 'Dossier non trouvé',
      LOAD_DOCS_ERROR: 'Erreur lors du chargement des documents du dossier',
    },
    SCOPE: {
      ADMINS: 'Admins',
      UNDEFINED: 'Non défini',
    },
  },
}
